export const translations = {
  code: {
    pt: 'Código',
    en: 'Code',
    de: 'Code',
    es: 'Código',
  },
  country: {
    pt: 'País',
    en: 'Country',
    de: 'Land',
    es: 'País',
  },

  zipcode: {
    pt: 'CEP (Zipcode)',
    en: 'Zipcode',
    de: 'Postleitzahl',
    es: 'Código postal',
  },
  city: {
    pt: 'Cidade',
    en: 'City',
    de: 'Stadt',
    es: 'Ciudad',
  },
  state: {
    pt: 'Estado',
    en: 'State',
    de: 'Bundesland',
    es: 'Estado',
  },
  neighborhood: {
    pt: 'Bairro',
    en: 'Neighborhood',
    de: 'Nachbarschaft',
    es: 'Barrio',
  },
  street: {
    pt: 'Rua',
    en: 'Street',
    de: 'Straße',
    es: 'Calle',
  },
};
